import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import WhatIsSection from '@/pages/home/components/WhatIsSection';
import WhyUseSection from '@/pages/home/components/WhyUseSection';
import ArticlePreview from '@/pages/home/components/ArticlePreview';
import FAQSection from '@/pages/home/components/FAQSection';
import { faqItems } from '@/mocks/categories';

const siteOrigin = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.sbs';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Basetao Spreadsheet Hub',
  url: siteOrigin,
  description: 'The ultimate resource for Basetao Spreadsheet guides, reviews, shipping costs, warehouse tips, coupons, and expert buying resources for smart shopping.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteOrigin}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <WhatIsSection />
        <WhyUseSection />
        <ArticlePreview />
        <FAQSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}